import { connect, ConnectedProps } from 'react-redux';
import { resetRequestState } from '../../actions/requests';
import {
  collapseCard,
  expandCard,
  hideCardAddedMessage,
  hideRemovalConfirmation,
  showRemovalConfirmation,
} from '../../actions/ui';
import {
  selectMarkCardPrimaryFailed,
  selectRemoveError,
  selectRemoveLoading,
  selectIsRTLLocale,
  selectCanAddPaymentMethod,
} from '../../selectors/appState';
import { selectCardList, selectExpandedCard, selectFailedMarkPrimaryCardId } from '../../selectors/creditCard';
import { selectDeviceType } from '../../selectors/deviceType';
import { selectExpandedCardId, selectShowCardAddedMessage, selectShowRemovalConfirmation } from '../../selectors/ui';
import { IStoreState } from '../../types/StoreState';
import { CardsList } from './view';

const mapStateToProps = (state: IStoreState) => ({
  cards: selectCardList(state),
  canAddPaymentMethod: selectCanAddPaymentMethod(state),
  deviceType: selectDeviceType(state),
  expandedCardId: selectExpandedCardId(state),
  expandedCard: selectExpandedCard(state),
  showRemoveConfirmation: selectShowRemovalConfirmation(state),
  isMarkCardPrimaryFailed: selectMarkCardPrimaryFailed(state),
  isRemovingInProcess: selectRemoveLoading(state),
  isRemovingFailed: selectRemoveError(state),
  failedMarkPrimaryCardId: selectFailedMarkPrimaryCardId(state),
  rtl: selectIsRTLLocale(state),
  showCardAddedMessage: selectShowCardAddedMessage(state),
});

const mapDispatchToProps = {
  resetRequestState,
  expandCard,
  collapseCard,
  requestRemoval: showRemovalConfirmation,
  declineRemoval: hideRemovalConfirmation,
  closeFailedMarkPrimaryErrorMessage: () => (dispatch) => {
    return dispatch(resetRequestState('markCardPrimary'));
  },
  closeFailedDeleteCardMessage: () => (dispatch, getState) => {
    const { primary } = selectExpandedCard(getState());
    return primary ? dispatch(resetRequestState('deletePrimaryCard')) : dispatch(resetRequestState('deleteCard'));
  },
  hideCardAddedMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ICardsListConnectedProps = ConnectedProps<typeof connector>;
export const CardsListConnect = connector(CardsList);
